import React from "react";

import DestaquePrincipal from "../NoticiaCard/Destaque/Principal";

import { CarouselComponent } from "../CarouselComponent";

export function NewsCarousel({ noticias }) {
  return (
    <CarouselComponent>
      {noticias.map((noticia, index) => {
        return (
          <>
            <DestaquePrincipal
              key={index}
              categorias={noticia.categorias}
              data={noticia.data_de_publicacao}
              img={noticia.noticia_img_path}
              titulo={noticia.titulo}
              previa={noticia.previa_texto}
              to={`/noticias/${noticia.id}`}
            />
          </>
        );
      })}
    </CarouselComponent>
  );
}
